module.exports = __webpack_public_path__ + "static/media/test6_3.131c84ae.png";